
import React from 'react';
import KPIValues from './KPIValues';
import { SPIHeaderTitle } from '../styled';

const UserHeader = ({ config, selectedKPIConfig, selectedKPIConfigID }) => (
  <div>
    <SPIHeaderTitle>
      Select KPI
    </SPIHeaderTitle>
    <KPIValues
      config={config}
      selectedKPIConfig={selectedKPIConfig}
      selectedKPIConfigID={selectedKPIConfigID}
    />
  </div>

);

export default UserHeader;
